import { useForm } from "react-hook-form";
import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useDispatch, useSelector } from "react-redux";
import {
  createTask,
  fetchTaskById,
  updateTask,
} from "../redux/Slices/TasksSlice";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

function EditTaskPage() {
  <Toaster
    position="top-center"
    reverseOrder={false}
    gutter={8}
    containerClassName=""
    containerStyle={{}}
    toastOptions={{
      className: "",
      duration: 5000,
      removeDelay: 1000,
      style: {
        background: "#363636",
        color: "#fff",
      },

      success: {
        duration: 3000,
        iconTheme: {
          primary: "green",
          secondary: "black",
        },
      },
    }}
  />;
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const taskId = location.state?.id;
  const { task } = useSelector((state) => state.tasksReducer);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
  } = useForm({ mode: "onChange" });

  const [categories, setCategories] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [selectedDate, setSelectedDate] = React.useState(null);

  React.useEffect(() => {
    if (taskId) {
      dispatch(fetchTaskById(taskId));
    }
  }, [taskId, dispatch]);

  React.useEffect(() => {
    if (task) {
      setValue("taskName", task.taskName || "");
      setCategories(task.categories || "");
      setStatus(task.Status || "");
      const taskDate = task?.Date ? dayjs(task.Date) : null;
      if (taskDate && taskDate.isValid()) {
        setSelectedDate(taskDate);
        setValue("Date", taskDate.toISOString());
      } else {
        setSelectedDate(null);
        setValue("Date", "");
      }
    }
  }, [task, setValue]);

  const handleDateChange = (newValue) => {
    if (newValue && dayjs(newValue).isValid()) {
      setSelectedDate(newValue);
      setValue("Date", dayjs(newValue).toISOString(), { shouldValidate: true });
    } else {
      setSelectedDate(null);
      setValue("Date", "", { shouldValidate: true });
    }
  };

  const onSubmit = async (data) => {
    try {
      const taskData = {
        ...data,
        categories,
        Status: status,
        Date: selectedDate ? dayjs(selectedDate).format("DD/MM/YYYY") : null,
      };
      setTimeout(() => {
        navigate("/");
      }, 3000);
      if (taskId) {
        await dispatch(updateTask({ id: taskId, taskData }));
        toast.success("Task updated successfully ");
      } else {
        await dispatch(createTask(taskData));
        toast.error("Task created successfully");
      }
    } catch (error) {
      console.error("Failed to create/update task:", error);
      alert("Failed to process the task.");
    }
  };

  return (
    <>
      <Toaster />

      <div className="container-fluid mt-5 d-flex flex-col align-items-center">
        <h2 className="text-center mb-4">Update Task</h2>

        <form
          onSubmit={handleSubmit(onSubmit)}
          className="border p-4 rounded shadow-sm w-75"
        >
          {/* Task Name */}
          <Box component="div" sx={{ mt: 1, mb: 1 }}>
            <TextField
              id="taskName"
              label="Task Name"
              variant="outlined"
              fullWidth
              error={!!errors.taskName}
              helperText={errors.taskName?.message}
              {...register("taskName", {
                required: "Task name is required",
                maxLength: {
                  value: 9,
                  message: "Task name cannot exceed nine characters",
                },
              })}
            />
          </Box>

          {/* Categories Dropdown */}
          <FormControl sx={{ mt: 1, mb: 1, minWidth: "100%" }}>
            <Select
              labelId="categories"
              id="categories"
              value={categories}
              onChange={(e) => setCategories(e.target.value)}
              fullWidth
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value="Work">Work</MenuItem>
              <MenuItem value="Personal">Personal</MenuItem>
            </Select>
            <FormHelperText>{errors.categories?.message}</FormHelperText>
          </FormControl>

          {/* Status Dropdown */}
          <FormControl sx={{ mt: 1, mb: 1, minWidth: "100%" }}>
            <InputLabel id="status">Status</InputLabel>
            <Select
              labelId="status"
              id="status"
              value={status}
              label="status"
              onChange={(e) => setStatus(e.target.value)}
              fullWidth
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Completed">Completed</MenuItem>
            </Select>
            <FormHelperText>{errors.status?.message}</FormHelperText>
          </FormControl>

          {/* Due Date */}
          <FormControl
            sx={{ mt: 1, mb: 1, minWidth: "100%" }}
            error={!!errors.Date}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Due Date"
                value={selectedDate}
                onChange={handleDateChange}
                textField={(params) => (
                  <TextField {...params} fullWidth error={!!errors.Date} />
                )}
              />
            </LocalizationProvider>
            <FormHelperText>{errors.Date?.message}</FormHelperText>
          </FormControl>
          <input
            type="hidden"
            {...register("Date", { required: "Date is required" })}
          />

          {/* Submit Button */}

          <button type="submit" className="btn btn-primary w-100">
            {isSubmitting ? "Updateing..." : "Update Task"}
          </button>
        </form>
      </div>
    </>
  );
}

export default EditTaskPage;
